import { Text } from '@croquiscom-pvt/zds';

import { SelectBoxDropdown } from '../../../component/option/select-box-dropdown/SelectBoxDropdown';
import { SelectBoxItem } from '../../../component/option/select-box-item/SelectBoxItem';
import type { SelectBoxDropdownItem, SelectBoxItemData } from '../../../type/common.type';

interface AdditionalOptionsSectionProps {
  display: boolean;
  display_header_text: boolean;
  additional_option_dropdown_list: SelectBoxDropdownItem[];
  additional_dropdown_state: boolean;
  additional_ref: React.RefObject<HTMLParagraphElement>;
  actions: {
    handleClickAdditionalSelectBoxDropdown: (disabled: boolean) => void;
    handleAnimationComplete: (isOpen: boolean) => void;
  };
}

export const AdditionalOptionsSection = (props: AdditionalOptionsSectionProps) => {
  const {
    display,
    display_header_text,
    additional_option_dropdown_list,
    additional_dropdown_state,
    additional_ref,
    actions,
  } = props;

  if (!display) {
    return null;
  }

  return (
    <>
      {display_header_text && (
        <Text
          ref={additional_ref}
          variant='Body_14_SemiBold'
          v3Color='gray700'
          style={{ marginTop: 20, marginBottom: 8 }}
        >
          추가 상품
        </Text>
      )}
      {additional_option_dropdown_list.map(({ selected_option_name, placeholder, data, disabled = false }) => (
        <SelectBoxDropdown
          key={placeholder}
          open={additional_dropdown_state}
          placeholder={placeholder}
          label={selected_option_name}
          handleClick={() => actions.handleClickAdditionalSelectBoxDropdown(disabled)}
          handleAnimationComplete={() => actions.handleAnimationComplete(additional_dropdown_state)}
        >
          {data.map((item: SelectBoxItemData) => (
            <SelectBoxItem key={item.option.id} {...item} />
          ))}
        </SelectBoxDropdown>
      ))}
    </>
  );
};
